import React, { FC, useState } from 'react';

import { Button, type ButtonProps, useToaster } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { ActionButtonTheme } from 'client/utils/draft-actions';
import * as keyset from 'i18n/GeneralSettings';

import styles from './AliceAppActionButton.module.scss';

interface Props {
    children: React.ReactNode;
    action: () => boolean | void | Promise<boolean | void>;
    disabled?: boolean;
    successLabel: string;
    size?: ButtonProps['size'];
    view?: ActionButtonTheme;
}

const ACTION_TOAST = 'ACTION_TOAST';
const t = i18n(keyset);

export const AliceAppActionButton: FC<Props> = ({ children, successLabel, action, disabled, size, view }) => {
    const [isLoading, setIsLoading] = useState(false);

    const { add: addToast } = useToaster();

    const onClick = async () => {
        try {
            setIsLoading(true);
            const succeeded = await action();

            if (succeeded !== false) {
                addToast && successLabel && addToast({ title: successLabel, theme: 'success', name: ACTION_TOAST });
            }
        } catch (_e) {
            addToast && addToast({ title: t('error'), theme: 'danger', name: ACTION_TOAST });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Button
            className={styles.aliceAppActionButton}
            onClick={onClick}
            disabled={disabled}
            view={view}
            loading={isLoading}
            size={size}
        >
            {children}
        </Button>
    );
};
